// Fetch helper function
import fetch from 'helpers/Fetch';

// Import API path/routes constant
import { URL_CUSTOMER_DETAIL } from 'constants/api';

const fetchCustomerDetailData = payload => {
  return fetch({
    url: URL_CUSTOMER_DETAIL,
    method: 'POST',
    data: payload,
  });
};

export { fetchCustomerDetailData };
